import React, { useRef, useMemo, memo } from "react"
import { motion } from "framer-motion"
import { useLiteModeContext } from "../../hooks/useLiteMode"

interface AnimatedBackgroundProps {
  className?: string
  particleCount?: number
  color?: string
}

/**
 * РџСЂРµРјРёР°Р»СЊРЅС‹Р№ 3D-РїРѕРґРѕР±РЅС‹Р№ Р°РЅРёРјРёСЂРѕРІР°РЅРЅС‹Р№ С„РѕРЅ РґР»СЏ Sheriff Barbershop
 * РЎРѕР·РґР°С‘С‚ СЌС„С„РµРєС‚ РіР»СѓР±РёРЅС‹ СЃ РїР»Р°РІР°СЋС‰РёРјРё С‡Р°СЃС‚РёС†Р°РјРё Рё РіСЂР°РґРёРµРЅС‚Р°РјРё
 * РћРїС‚РёРјРёР·РёСЂРѕРІР°РЅ РґР»СЏ РјРѕР±РёР»СЊРЅС‹С… СѓСЃС‚СЂРѕР№СЃС‚РІ
 * 
 * PERFORMANCE: Р’ lite mode РїРѕР»РЅРѕСЃС‚СЊСЋ РѕС‚РєР»СЋС‡Р°РµС‚СЃСЏ РёР»Рё СЃРёР»СЊРЅРѕ СѓРїСЂРѕС‰Р°РµС‚СЃСЏ
 */
const AnimatedBackgroundComponent: React.FC<AnimatedBackgroundProps> = ({
  className = "",
  particleCount = 30,
  color = "#d4af37", // Sheriff gold
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { isLiteMode, isMobile, prefersReducedMotion } = useLiteModeContext()

  // Р’ lite mode РЅРµ СЂРµРЅРґРµСЂРёРј РЅРёС‡РµРіРѕ
  if (isLiteMode || prefersReducedMotion) {
    return (
      <div
        className={`absolute inset-0 pointer-events-none ${className}`}
        style={{
          background: `radial-gradient(ellipse 80% 50% at 50% 0%, ${color}08 0%, transparent 50%)`,
        }}
      />
    )
  }

  // РЈРјРµРЅСЊС€Р°РµРј РєРѕР»РёС‡РµСЃС‚РІРѕ С‡Р°СЃС‚РёС† РЅР° РјРѕР±РёР»СЊРЅС‹С… РґР»СЏ РїСЂРѕРёР·РІРѕРґРёС‚РµР»СЊРЅРѕСЃС‚Рё
  const actualParticleCount = isMobile ? Math.min(particleCount, 8) : particleCount

  // Р“РµРЅРµСЂРёСЂСѓРµРј С‡Р°СЃС‚РёС†С‹ РѕРґРёРЅ СЂР°Р·
  const particles = useMemo(() => {
    return Array.from({ length: actualParticleCount }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: 2 + Math.random() * 3, // РЈРјРµРЅСЊС€РёР»Рё РјР°РєСЃРёРјР°Р»СЊРЅС‹Р№ СЂР°Р·РјРµСЂ
      duration: 20 + Math.random() * 15, // Р—Р°РјРµРґР»РёР»Рё Р°РЅРёРјР°С†РёСЋ
      delay: Math.random() * 10,
      opacity: 0.08 + Math.random() * 0.2, // РЈРјРµРЅСЊС€РёР»Рё СЏСЂРєРѕСЃС‚СЊ
    }))
  }, [actualParticleCount])

  return (
    <div
      ref={containerRef}
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
    >
      {/* РћСЃРЅРѕРІРЅРѕР№ РіСЂР°РґРёРµРЅС‚ */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse 80% 50% at 50% 0%, ${color}08 0%, transparent 50%),
            radial-gradient(ellipse 60% 40% at 100% 100%, ${color}05 0%, transparent 40%),
            radial-gradient(ellipse 50% 30% at 0% 50%, ${color}03 0%, transparent 30%)
          `,
        }}
      />

      {/* РђРЅРёРјРёСЂРѕРІР°РЅРЅС‹Рµ РІРѕР»РЅС‹ */}
      <motion.div
        className="absolute inset-0"
        animate={{
          background: [
            `radial-gradient(ellipse 100% 100% at 0% 0%, ${color}06 0%, transparent 50%)`,
            `radial-gradient(ellipse 100% 100% at 100% 100%, ${color}06 0%, transparent 50%)`,
            `radial-gradient(ellipse 100% 100% at 0% 100%, ${color}06 0%, transparent 50%)`,
            `radial-gradient(ellipse 100% 100% at 100% 0%, ${color}06 0%, transparent 50%)`,
            `radial-gradient(ellipse 100% 100% at 0% 0%, ${color}06 0%, transparent 50%)`,
          ],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear",
        }}
      />

      {/* РџР»Р°РІР°СЋС‰РёРµ С‡Р°СЃС‚РёС†С‹ */}
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          className="absolute rounded-full"
          style={{
            left: `${particle.x}%`,
            top: `${particle.y}%`,
            width: particle.size,
            height: particle.size,
            background: color,
            opacity: particle.opacity,
            boxShadow: `0 0 ${particle.size * 2}px ${color}`,
          }}
          animate={{
            y: [0, -30, 0],
            x: [0, Math.random() > 0.5 ? 15 : -15, 0],
            opacity: [particle.opacity, particle.opacity * 1.5, particle.opacity],
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: particle.duration,
            delay: particle.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}

      {/* Р“РѕСЂРёР·РѕРЅС‚Р°Р»СЊРЅС‹Рµ Р»РёРЅРёРё (Р±Р°СЂР±РµСЂС€РѕРї СЃС‚РёР»СЊ) */}
      <div className="absolute inset-0 opacity-[0.02]">
        {[...Array(8)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute left-0 right-0 h-px"
            style={{
              top: `${12.5 * (i + 1)}%`,
              background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
            }}
            animate={{
              opacity: [0.3, 0.6, 0.3],
              scaleX: [0.8, 1, 0.8],
            }}
            transition={{
              duration: 4 + i,
              delay: i * 0.5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      {/* Р¦РµРЅС‚СЂР°Р»СЊРЅРѕРµ СЃРІРµС‡РµРЅРёРµ - Р±РµР· blur РЅР° РјРѕР±РёР»СЊРЅС‹С… РґР»СЏ РїСЂРѕРёР·РІРѕРґРёС‚РµР»СЊРЅРѕСЃС‚Рё */}
      <motion.div
        className="absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full"
        style={{
          background: `radial-gradient(circle, ${color}06 0%, transparent 70%)`,
          filter: isMobile ? "none" : "blur(30px)", // РЈР±РёСЂР°РµРј blur РЅР° РјРѕР±РёР»СЊРЅС‹С…
        }}
        animate={{
          scale: [1, 1.1, 1], // РЈРјРµРЅСЊС€РёР»Рё Р°РјРїР»РёС‚СѓРґСѓ
          opacity: [0.4, 0.6, 0.4],
        }}
        transition={{
          duration: 10, // Р—Р°РјРµРґР»РёР»Рё
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* Noise overlay РґР»СЏ С‚РµРєСЃС‚СѓСЂС‹ */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.7' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        }}
      />
    </div>
  )
}

// РњРµРјРѕРёР·РёСЂСѓРµРј РєРѕРјРїРѕРЅРµРЅС‚ РґР»СЏ РїСЂРµРґРѕС‚РІСЂР°С‰РµРЅРёСЏ Р»РёС€РЅРёС… СЂРµ-СЂРµРЅРґРµСЂРѕРІ
export const AnimatedBackground = memo(AnimatedBackgroundComponent)
